

























































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import * as I from '@/interfaces';

interface Base {
  seqNo: number;
}

type PickProp =
  | 'seqNo'
  | 'targetEmpno'
  | 'targetName'
  | 'tempName'
  | 'targetCompanyName'
  | 'targetDivisionName'
  | 'targetDeptName'
  | 'targetDutyName'
  | 'targetPeriodTo'
  | 'targetPhone'
  | 'targetEmail';

type GeneralTable = Pick<I.TempGeneralHistoryList, PickProp>;

type TableHeader<T> = { [P in keyof T]: string };

const header: TableHeader<GeneralTable> = {
  seqNo: '순번',
  targetEmpno: '사원번호',
  targetName: '이름',
  tempName: '임시카드명',
  targetCompanyName: '회사',
  targetDivisionName: '사업장',
  targetDeptName: '부서',
  targetDutyName: '직위',
  targetPeriodTo: '종료일자',
  targetPhone: '전화번호',
  targetEmail: '이메일'
};

@Component
export default class extends Mixins(AxPage) {
  state = {
    issueVisible: false,
    itemList: [],
    tab: null,
    tabItems: [
      { tab: 'One', content: 'Tab 1 Content' },
      { tab: 'Two', content: 'Tab 2 Content' },
      { tab: 'Three', content: 'Tab 3 Content' },
      { tab: 'Four', content: 'Tab 4 Content' },
      { tab: 'Five', content: 'Tab 5 Content' },
      { tab: 'Six', content: 'Tab 6 Content' },
      { tab: 'Seven', content: 'Tab 7 Content' },
      { tab: 'Eight', content: 'Tab 8 Content' },
      { tab: 'Nine', content: 'Tab 9 Content' }
    ]
  };

  generalList: I.TempGeneralHistoryList[] = [];

  async prepare() {
    const baseData = await this.getBaseData();
    console.log(baseData);
    if (baseData) {
      this.generalList = baseData.sort(x => x.seqNo).reverse();
    }
  }

  async getBaseData() {
    const result = await this.API.call.temp.generalGet('');
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
  test = '1234';
  search = '';

  get headers() {
    return Object.entries(header).map(([value, text]) => {
      return { text, value };
    });
  }

  async onSearch() {
    const result = await this.API.call.temp.generalGet(this.search);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      if (result) {
        this.generalList = result.data.sort(x => x.seqNo).reverse();
      }
    }
  }

  onAddClicked() {
    const callback = async () => {
      await this.onSearch();
    };

    this.showDialog({
      type: 'AxTempGeneralNewDialog',
      props: {
        callback
      }
    });
  }

  onRetrunClick(generalList: I.TempGeneralHistoryList) {
    const callback = async () => {
      await this.onSearch();
    };

    this.showDialog({
      type: 'AxTempGeneralReturnDialog',
      props: {
        generalList,
        callback
      }
    });
  }

  onHistoryClicked() {
    const callback = async () => {
      await this.onSearch();
    };

    this.showDialog({
      type: 'AxTempGeneralHistoryDialog',
      //type: 'AxUserRegisterDialog',
      props: {
        callback
      }
    });
  }

  async onRowItemClicked(item: I.TempGeneralHistoryList) {
    const tempItem = item as I.TempGeneralHistoryList;
    const result = await this.showConfirmModal(
      '확인',
      `사원번호 : ${tempItem.targetEmpno}<br />성명 : ${tempItem.targetName}<br />임시증 : ${tempItem.tempName}<br /><br />선택된 내역을 반납하시겠습니까?`
    );
    if (result === 0) {
      this.onRetrunClick(item);
    }
  }
}
